import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Col, Container, InputGroup, Row } from "react-bootstrap";
import {
  ENTER_PUMP_RATE,
  ENTER_VALID_PUMP_RATE,
} from "../../../configurations/MessageConstants";

function PumpRate(props) {
  const [validated, setValidated] = useState(false);
  const mounted = useRef(true);
  const pumpRateTypeInput = useRef();

  const back = (e) => {
    e.preventDefault();
    props.prevStep();
  };

  const saveAndContinue = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      props.nextStep();
    }
    setValidated(true);
  };

  useEffect(() => {
    if (mounted.current) {
      mounted.current = false;
    } else {
      pumpRateTypeInput.current.focus();
    }
  }, [props.inputValues.pumpRateType]);

  return (
    <Container>
      <br></br>
      <h3 className="mt-2">Pump Rate</h3>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveAndContinue}>
        <div className="well-test-form-body">
          <p className="well-test-pumprate">
            Pump Rate: (Gallons Per Minute): Please fill in the rate for the
            appropriate system in its current position when arriving at the
            well. If there is the ability to override the controls (end gun,
            swing arm) to get other readings it would be beneficial but not
            required. Only do the extra readings if it can be done in a timely
            manner and as efficiently as possible. If there’s a special
            condition on site, please note in the Well Test Notes input field
            below.
          </p>
          <Row>
            <Form.Group as={Col} md="6">
              <Form.Label className="label required-field">
                Pump Rate Type
              </Form.Label>
              <Col sm={10}>
                <Form.Check
                  className="gap-2"
                  type="radio"
                  value="PON"
                  label="Pivot only, swing arm and end gun off"
                  name="pumpRateType"
                  id="PON"
                  required
                  onChange={props.handleChange}
                  checked={props.inputValues.pumpRateType === "PON"}
                />
                <Form.Check
                  className="gap-2"
                  type="radio"
                  value="PWS"
                  label="Pivot and swing arm on, end gun off"
                  name="pumpRateType"
                  id="PWS"
                  onChange={props.handleChange}
                  checked={props.inputValues.pumpRateType === "PWS"}
                />
                <Form.Check
                  className="gap-2"
                  type="radio"
                  value="PWE"
                  label="Pivot with end gun on, swing arm off"
                  name="pumpRateType"
                  id="PWE"
                  onChange={props.handleChange}
                  checked={props.inputValues.pumpRateType === "PWE"}
                />
                <Form.Check
                  className="gap-2"
                  type="radio"
                  value="PSE"
                  label="Pivot with swing arm and end gun on"
                  name="pumpRateType"
                  id="PSE"
                  onChange={props.handleChange}
                  checked={props.inputValues.pumpRateType === "PSE"}
                />
                <Form.Check
                  className="gap-2"
                  type="radio"
                  value="FLD"
                  label="Flood"
                  name="pumpRateType"
                  id="FLD"
                  onChange={props.handleChange}
                  checked={props.inputValues.pumpRateType === "FLD"}
                />
                <InputGroup as={Col} md="6" className="ps-0 gap-2">
                  <Form.Check
                    className="gap-2"
                    type="radio"
                    value="OTH"
                    label="Other"
                    name="pumpRateType"
                    id="OTH"
                    onChange={props.handleChange}
                    checked={props.inputValues.pumpRateType === "OTH"}
                  />

                  <Form.Control
                    ref={pumpRateTypeInput}
                    type="text"
                    autoComplete="off"
                    defaultValue={props.inputValues.otherPumpRateType}
                    name="otherPumpRateType"
                    onChange={props.handleChange}
                    placeholder="Enter type"
                    className={
                      props.inputValues.pumpRateType === "OTH"
                        ? "h-25 p-1 ms-2 "
                        : "d-none"
                    }
                  />
                </InputGroup>
              </Col>
            </Form.Group>
            <Form.Group as={Col} md="3">
              <Form.Label className="label required-field">
                Pump Rate
              </Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                defaultValue={props.inputValues.pumpRate}
                name="pumpRate"
                required
                onChange={props.handleChange}
                pattern="^[0-9]*"
                className="form-control"
              />
              <Form.Control.Feedback type="invalid">
                {props.inputValues.pumpRate
                  ? ENTER_VALID_PUMP_RATE
                  : ENTER_PUMP_RATE}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
        </div>
        <Button variant="primary" onClick={back}>
          Back
        </Button>{" "}
        <Button variant="primary" className="well-test-next-btn" type="submit">
          Next
        </Button>
      </Form>
    </Container>
  );
}

export default PumpRate;
